<button type="button"
        class="_group-option"
        [class._selected]="selected"
        [style.min-width]="minWidth || 0">
    <span class="p2">{{label | translate}}</span>
</button>
